import { render, staticRenderFns } from "./TheGlobalDialogs.vue?vue&type=template&id=f9fb1660"
import script from "./TheGlobalDialogs.vue?vue&type=script&lang=js"
export * from "./TheGlobalDialogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports